import { Box, TableCell } from "@mui/material";
import { renderFieldView } from "../../../../../components/fieldsViews/renderFieldView";
import { FormatedField } from "../../../../../types/fields.types";
import { ServiceProvided } from "../../types";
import { SingleValueCustomChip } from "../../../../../components/chips/SingleValueCustomChip";

type BaseInfoTableCellsProps = {
	serviceProvided: ServiceProvided;
	fieldSessionPeriodicity: FormatedField;
};

export const BaseInfoTableCells = ({ serviceProvided, fieldSessionPeriodicity }: BaseInfoTableCellsProps) => {
	return (
		<>
			<SessionQuantityTableCell serviceProvided={serviceProvided} />
			<TableCell align="center">
				{
					<Box display="flex" justifyContent="center">
						{fieldSessionPeriodicity &&
							renderFieldView(
								fieldSessionPeriodicity,
								{ session_periodicity: serviceProvided.session_periodicity },
								"group"
							)}
					</Box>
				}
			</TableCell>
		</>
	);
};

const SessionQuantityTableCell = ({ serviceProvided }: { serviceProvided: ServiceProvided }) => {
	const sessionQuantity = serviceProvided.session_quantity === 0 ? "Não Aplicável" : serviceProvided.session_quantity;
	if (typeof sessionQuantity === "number") {
		return <TableCell align="center">{serviceProvided.session_quantity}</TableCell>;
	} else {
		return (
			<TableCell align="center">
				<SingleValueCustomChip text="Não Aplicável" />
			</TableCell>
		);
	}
};
